<style>
    .error-wrapper {
        font-family: 'Nunito Sans', sans-serif;
        position: relative;
        overflow: hidden;
        background-color: #00000099;
        border-radius: 4px;
        /* width: 280px;
        aspect-ratio: 2; */
        color: white;
        z-index: 1;

    }

    .error-content {
        display: flex;
        height: 100%;
        flex-direction: column;

    }

    .error-message {
        background-color: #ff000055;

        flex: 1 1 auto;
    }

    .error-header {
        background-color: #ff000055;
        box-sizing: border-box;
        width: 100%;
        padding: 15px;
        display: flex;
        justify-content: space-between;
    }

    .error-between {
        background-color: #fff;
        position: relative;

        height: 1px;
        width: 100%;
    }

    .error-shadow {
        position: absolute;
        width: 33%;
        top: -5%;
        height: 50%;
        right: -5%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: -1;
    }

    .error-message {
        padding: 20px;

    }

    .hexagon {
        width: 100%;
        height: 100%;
        background-color: #f003;
        clip-path: polygon(0%0%, 100% 0%, 100% 75%, 66% 100%, 33% 100%, 0% 75%);
    }

    .middle-svg-icon,
    .middle-svg-icon svg {
        height: 100%;
        width: 100%;
    }

    .hexagon {}
</style>

<div class="error-wrapper">
    <div class="error-content">
        <div class="error-header">
            <div class="error-title">Error</div>
            <div class="error-close">x</div>
        </div>
        <div class="error-between">

        </div>
        <div class="error-message">
            {{data?`${data.message}`:`${dialogData?dialogData.message:'An error occurred.' }`}}
        </div>

    </div>
    <div class="error-shadow">
        <div class="hexagon">
            <div class="middle-svg-icon">
                <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <!-- First line of the X -->
                    <line x1="30" y1="30" x2="70" y2="70" stroke="#f00" stroke-width="15" stroke-linecap="round">
                        <animate attributeName="x2" from="30" to="70" dur="0.3s" fill="freeze" />
                        <animate attributeName="y2" from="30" to="70" dur="0.3s" fill="freeze" />
                    </line>

                    <!-- Second line of the X -->
                    <line x1="70" y1="30" x2="30" y2="70" stroke="#f00" stroke-width="15" stroke-linecap="round">
                        <animate attributeName="x2" from="70" to="30" begin="0.3s" dur="0.3s" fill="freeze" />
                        <animate attributeName="y2" from="30" to="70" begin="0.3s" dur="0.3s" fill="freeze" />
                    </line>
                </svg>

            </div>
        </div>

    </div>
</div>